var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({attrs:{"rounded":_vm.rounded}},'v-btn',{ ..._vm.$attrs },false),_vm.$listeners),[_vm._t("default",function(){return [(_vm.t)?_c('span',{directives:[{name:"t",rawName:"v-t",value:(_vm.t),expression:"t"}]}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }